<template>
    <nav class="main-header navbar navbar-expand navbar-dark navbar-primary">
        <ul class="navbar-nav">
            <li class="nav-item">
                <a class="nav-link" data-widget="pushmenu" href="#" @click.prevent="collapse"><i class="fas fa-bars"></i></a>
            </li>
        </ul>
        <ul class="navbar-nav ml-auto">
            <li :class="'nav-item ' + (teatro.carrito_varios_eventos ? 'mr-4' : '')">
                <SelectTeatroComponent/>
            </li>
        </ul>
        <ul v-if="teatro.carrito_varios_eventos" class="navbar-nav">
            <li class="nav-item">
                <CarritoTaquilla button_color="white"/>
            </li>
        </ul>
        <ul class="navbar-nav">
            <li class="nav-item">
                <Notificaciones/>
            </li>
        </ul>
    </nav>
</template>

<script>
    import Notificaciones from '../notificaciones/Notificaciones';
    import SelectTeatroComponent from './SelectTeatroComponent.vue';
    import CarritoTaquilla from '../carrito/CarritoTaquilla.vue';

    export default {
        data() {
            return {

            }
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            teatro() {
                return this.$store.getters.getTeatro;
            }
        },
        methods: {
            collapse() {
                this.$emit('collapse');
            }
        },
        components: {
            Notificaciones, SelectTeatroComponent, CarritoTaquilla
        }
    }
</script>
